import { BaseWidget } from ".";
import { NumberControl } from "../controls/NumberControl";
import { TextControl } from "../controls/TextControl";
import TitleIcon from '@mui/icons-material/TitleOutlined';
import { ColorControl } from "../controls/ColorControl";
import { FontControl } from "../controls/grouped/FontControl";

export class HeadingWidget extends BaseWidget {
    
    getName() {
        return 'Kop';
    }

    getIcon() {
        return <TitleIcon />;
    }

    getControls() {
        return {
            'text': new TextControl({
                label: 'Tekst',
                description: 'Tekst van de kop',
                defaultValue: 'Lorem Ipsum',
            }),
            'level': new NumberControl({
                label: 'Niveau',
                description: 'Het niveau van de kop (1-6)',
                defaultValue: 1,
                options: {
                    min: 1,
                    max: 6,
                    step: 1
                }
            }),
            'font': new FontControl({
                label: 'Lettertype',
                description: 'Instellingen voor het lettertype van de kop',
                defaultValue: {
                    // fontFamily: 'Roboto',
                    fontSize: { value: 24, unit: 'px' },
                    alignment: 'left',
                },
            }),
            'color': new ColorControl({
                label: 'Kleur',
                description: 'Kleur van de kop',
                defaultValue: '#000000',
            })
        };
    }

    /**
     * @param {{
     *     [K in keyof ReturnType<typeof this.getControls>]: ReturnType<typeof this.getControls>[K]['defaultValue']
     * }} props
     * @returns {React.ReactNode}
     */
    render(props) {
        return <HeadingRenderer {...props}>
            {props.text}
        </HeadingRenderer>;
    }
}

/**
 * @param {{
 *     [K in keyof ReturnType<HeadingWidget['getControls']>]: ReturnType<HeadingWidget['getControls']>[K]['defaultValue']
 * } & { children: any }} props
 * @returns {JSX.Element}
 */
const HeadingRenderer = ({ level, font, color, children }) => {
    const Tag = `h${level ?? 1}`;
    // @ts-ignore
    return <Tag style={{
        textAlign: font?.alignment,
        fontFamily: font?.fontFamily,
        fontSize: font?.fontSize && `${font.fontSize.value}${font.fontSize.unit}`,
        fontStyle: font?.fontStyle,
        fontWeight: font?.fontWeight,
        textDecoration: font?.textDecoration,
        color: color
    }}>{children}</Tag>;
    // return <Tag style={{ textAlign: alignment, ...style }}>{children}</Tag>;
};
